import Header from "../header";
import "./Layout.scss";
import { Row, Col, Card, EventHandler } from "client/CommonComponents";
import Sidebar from "../Sidebar";
import { headerTiles } from "../../utils/constant";

interface IProps {
  children?: any;
}
const Layout = ({ children }: IProps) => {
  return (
    <>
      <Header  data-attribute="Layout_Default_Header" />
      <div className="main-administration-wrapper">
        <Row>
          <Col xs={4} sm={4} md={4} lg={4} xl={4}>
            <div className="mb-4">
              <Sidebar />
            </div>
          </Col>
          <Col
            xs={8}
            sm={8}
            md={8}
            lg={8}
            xl={8}
            className="mb-4 mb-md-0 order-1 pe-0"
          >
            <div className="mb-2 sub-header">
              <Card data-attribute="Layout_Default_Card">
                <div className="create-new-order-container">
                  <div className="create-new-order-block mb-md-3">
                    {headerTiles.map((item: any, index: any) => {
                      return (
                        <div
                          key={index}                        
                          className={`create-new-order ${item?.icontype}`}
                          data-attribute={`Layout_CreateNewOrder_${index}`}
                        >
                          <div className="pull-left">
                                  <p className="order-type">{item.text}</p>
                             <EventHandler onEvent={(e: any) => e.preventDefault()} data-attribute={`Layout_CreateNewOrder_${index}_EventHandler`}>
                               <a className="order-link" href="/" >
                              {item.link}
                               </a>
                            </EventHandler>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </Card>
            </div>
            <div className="right-block">{children}</div>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default Layout;
